<template>
  <NavigationHeader :title="wp.title" />
</template>

<script>
export default {
  name: 'ResourcesHeader',
  inject: ['wp']
}
</script>
